export default class header {
  constructor(opt = {}) {
    this.media = opt.media;
  }
  init() {
    if(this.media === 'pc'){
      this.pcMegaMenu()
      this.headerFollow();
    }else{
      this.spMenu();
    }
  }

  search(){
    var searchWrapper = $('.l-header_search'),
        searchInput = $('.l-header_search_input');
    document.addEventListener('click', function(e){
      var clickDocument = e.target.className;
      if (e.target.className.indexOf('l-header_search')) {
        searchWrapper.removeClass('is-focused');
      } else {
        searchWrapper.addClass('is-focused');
        searchInput.focus();
      }
    });
  }

  pcMegaMenu(){
    $('.js-nav_item').hover(function(){
      $(this).find('.l-header_nav_link').addClass('is-current');
      $(this).find('.l-header_nav_sub').show();
    }, function(){
      $(this).find('.l-header_nav_link').removeClass('is-current');
      $(this).find('.l-header_nav_sub').hide();
    });
    this.search();
  }

  spMenu(){
    $('.js-nav_btn').click(function(){
      $('.js-sp_menu').slideToggle();
      $('.l-header').toggleClass('is-open');
      $(this).toggleClass('is-open');
    });
    $(document).on('click', '.js-nav_item .l-header_nav_link', function(){
      $(this).toggleClass('is-open').next('.l-header_nav_sub').slideToggle();
      return false;
    });
  }

  headerFollow(){
    var $win = $(window),
        $header = $('.l-header'),
        FollowClass = 'is-follow',
        navPos = $header.offset().top,
        navHeight = $header.outerHeight();

    $win.on('load scroll', function() {
      var value = $(this).scrollTop();
      if ( value > navHeight ) {
        $header.addClass(FollowClass);
      } else {
        $header.removeClass(FollowClass);
      }
    });
  }


}


// WEBPACK FOOTER //
// ./src/assets/js/modules/header.js